import { render, staticRenderFns } from "./SurveyCompareSection.vue?vue&type=template&id=516fb8fb"
import script from "./SurveyCompareSection.vue?vue&type=script&lang=js"
export * from "./SurveyCompareSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports